import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
const comparison = [{
  sit: 'Huésped escribe a las 2 AM',
  without: 'Tu celular suena',
  with: 'IA responde en 30 segundos'
}, {
  sit: '3 rotaciones de limpieza el mismo sábado',
  without: 'Caos por WhatsApp',
  with: 'App envía alertas automáticas'
}, {
  sit: 'Pricing de 5 propiedades para el feriado',
  without: '2 horas de trabajo manual',
  with: 'Software ajusta solo en tiempo real'
}, {
  sit: 'Reportes mensuales para 5 dueños',
  without: 'Medio día de trabajo',
  with: 'Template se genera automáticamente'
}, {
  sit: 'Escalar a 15-20 propiedades',
  without: 'Imposible solo',
  with: 'El sistema lo hace sin vos'
}];
export function AutopilotSection() {
  return <section className="py-20 bg-white" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 text-secondary rounded-2xl mb-6" data-id="element-21">
            <Zap className="w-8 h-8" data-id="element-22" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-23">
            🚀 ¿Qué agrega el Airbnb Agency Autopilot?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10 pb-4" data-id="element-24">
          <table className="w-full min-w-[600px] border-collapse" data-id="element-25">
            <thead data-id="element-26">
              <tr data-id="element-27">
                <th className="text-left p-4 bg-gray-50 rounded-tl-xl text-gray-600 font-semibold border-b border-gray-200" data-id="element-28">
                  Situación
                </th>
                <th className="text-left p-4 bg-red-50 text-red-700 font-semibold border-b border-red-100" data-id="element-29">
                  ❌ Sin Autopilot
                </th>
                <th className="text-left p-4 bg-green-50 rounded-tr-xl text-green-700 font-semibold border-b border-green-100" data-id="element-30">
                  ✅ Con Autopilot
                </th>
              </tr>
            </thead>
            <tbody data-id="element-31">
              {comparison.map((row, i) => <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50/50 transition-colors" data-id="element-32">
                  <td className="p-4 text-gray-900 font-medium text-sm" data-id="element-33">
                    {row.sit}
                  </td>
                  <td className="p-4 text-red-600/80 text-sm" data-id="element-34">{row.without}</td>
                  <td className="p-4 text-green-700 font-semibold text-sm" data-id="element-35">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-surface rounded-2xl p-6 border border-gray-200" data-id="element-36">
          <p className="text-lg font-bold text-gray-900" data-id="element-37">
            Recuperás 20+ horas mensuales.{' '}
            <span className="text-primary" data-id="element-38">
              Esas horas las usás para cerrar más propiedades.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}